import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import {
  configApiRef,
  microsoftAuthApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import {
  SignInPageBlueprint,
  SignInPageProps,
} from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

const microsoftProvider = {
  id: 'microsoft-auth-provider',
  title: 'Microsoft',
  message: 'Sign in using Microsoft',
  apiRef: microsoftAuthApiRef,
};

const SignInResolver = (props: SignInPageProps) => {
  const environment = useApi(configApiRef).getOptionalString(
    'auth.environment',
  );
  if (environment === 'development') {
    return (
      <SignInPage {...props} providers={['guest', microsoftProvider]} />
    );
  }
  return <SignInPage {...props} provider={microsoftProvider} />;
};

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => <SignInResolver {...props} />,
  },
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    homeModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
